module.exports = __webpack_public_path__ + "static/media/de.9789ac5f.pdf";